import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-164502c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal-backdrop"
}
const _hoisted_2 = { class: "modal2" }
const _hoisted_3 = { class: "modal-header flex-row flex-align-center" }
const _hoisted_4 = { class: "text-center flex-1 modal-header-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#333",
    d: "M14 12.461 8.3 6.772l5.234-5.233L12.006 0 6.772 5.234 1.54 0 0 1.539l5.234 5.233L0 12.006l1.539 1.528L6.772 8.3l5.69 5.7L14 12.461z"
  })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body flex-row flex-wrap" }
const _hoisted_8 = { class: "table table-borderless" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "td-avg6" }),
  /*#__PURE__*/_createElementVNode("td", { class: "td-avg6" }),
  /*#__PURE__*/_createElementVNode("td", { class: "td-avg6" }),
  /*#__PURE__*/_createElementVNode("td", { class: "td-avg6" }),
  /*#__PURE__*/_createElementVNode("td", { class: "td-avg6" }),
  /*#__PURE__*/_createElementVNode("td", { class: "td-avg6" })
], -1))
const _hoisted_10 = { colspan: "2" }
const _hoisted_11 = { class: "mb-1" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "customer-name" }, "姓名:", -1))
const _hoisted_13 = { colspan: "2" }
const _hoisted_14 = { class: "mb-1" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "customer-mobile" }, "手机:", -1))
const _hoisted_16 = { colspan: "2" }
const _hoisted_17 = { class: "mb-1" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "customer-idcard" }, "身份证:", -1))
const _hoisted_19 = { colspan: "2" }
const _hoisted_20 = {
  class: "mb-1",
  selector: "angular-datepicker-input"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "customer-createdTime" }, "入住日期:", -1))
const _hoisted_22 = { colspan: "2" }
const _hoisted_23 = { class: "mb-1" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "customer-leaveTime" }, "离店日期:", -1))
const _hoisted_25 = { colspan: "2" }
const _hoisted_26 = { class: "mb-1" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "customer-roomNo" }, "入住房号:", -1))
const _hoisted_28 = { class: "modal-footer2 flex-row-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.customer.id ? '编辑' : '添加'), 1),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
              class: "modal-header-close"
            }, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.customer.name) = $event)),
                      disabled: true
                    }, null, 512), [
                      [_vModelText, _ctx.customer.name]
                    ])
                  ])
                ]),
                _createElementVNode("td", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _withDirectives(_createElementVNode("input", {
                      type: "tel",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.customer.mobile) = $event)),
                      disabled: true
                    }, null, 512), [
                      [_vModelText, _ctx.customer.mobile]
                    ])
                  ])
                ]),
                _createElementVNode("td", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.customer.idcard) = $event)),
                      disabled: true
                    }, null, 512), [
                      [_vModelText, _ctx.customer.idcard]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.customer.createdTime) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.customer.createdTime]
                    ])
                  ])
                ]),
                _createElementVNode("td", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.customer.leaveTime) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.customer.leaveTime]
                    ])
                  ])
                ]),
                _createElementVNode("td", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.customer.roomNo) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.customer.roomNo]
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
            }, "确定")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}